import { fg } from '@atlassian/jira-feature-gating';

const csmOmniSourceChannelCfFeRelayProvider = {
	get(): boolean {
		return fg('csm_omni_source_channel_cf_fe');
	},
};

export default csmOmniSourceChannelCfFeRelayProvider;
